import { Button, Form } from "devextreme-react";
import { ButtonItem, GroupItem, Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import React, { useRef, useState } from "react";
import BaseFormWithBreadCrumbs from "../../../components/base-form/base-form";
import { useScreenSize } from "../../../utils/media-query";
import { useLookupGroup } from "../../../contexts/lookup-group-context";
import { useEffect } from "react";
import { useAuth } from "../../../contexts/auth";
import { lookupGroups } from "../../../utils/lookup-groups.ts";



function Salary({ employeeId }) {

    const [formData, setFormData] = useState(
        {
            employeeId: "",
            salaryCalculationTypeId: "",
            amount: 0,
            salaryPaymentDayId: "",
            salaryPaymentMethodId: "",
            id: ""
        }
    )
    const [readOnly, setReadOnly] = useState(false)
    const [dirty, setDirty] = useState(false)
    const screenSize = useScreenSize()
    const formRef = useRef()
    const { getLookupData } = useLookupGroup()
    const { activeLanguage } = useAuth()
    const [salaryPaymentMethodList, setSalaryPaymentMethodList] = useState()
    const [salaryPaymentDayList, setSalaryPaymentDayList] = useState()
    const [salaryCalculationTypeList, setSalaryCalculationTypeList] = useState()

    const salaryPaymentMethodOptions = {
        items: salaryPaymentMethodList,
        valueExpr: "id",
        displayExpr: "text"
    }

    const salaryPaymentDayOptions = {
        items: salaryPaymentDayList,
        valueExpr: "id",
        displayExpr: "text",
        searchEnabled: true
    }

    const salaryCalculationTypeOptions = {
        items: salaryCalculationTypeList,
        valueExpr: "id",
        displayExpr: "text",

    }

    const handleFieldDataChanged = (e) => {
        setDirty(true)
    }

    useEffect(() => {
        getLookupData(lookupGroups.salaryPaymentMethod).then(response => setSalaryPaymentMethodList(response))
        getLookupData(lookupGroups.salaryPaymentDay).then(response => setSalaryPaymentDayList(response))
        getLookupData(lookupGroups.salaryCalculationType).then(response => setSalaryCalculationTypeList(response))

    }, [activeLanguage])

    return (
        <React.Fragment>
            <BaseFormWithBreadCrumbs
                formData={formData}
                setFormData={setFormData}
                formRef={formRef}
                readOnly={readOnly}
                setReadOnly={setReadOnly}
                dirty={dirty}
                setDirty={setDirty}
                initialValues={{ employeeId: employeeId }}
                loadId={employeeId}
                loadUrl={"/api/EmployeeSalary/Employee/"}
                updateUrl={"/api/EmployeeSalary/FormData"}
            >
                <Form
                    width={600}
                    labelLocation={screenSize.isXSmall ? "top" : "left"}
                    formData={formData}
                    readOnly={readOnly}
                    onFieldDataChanged={handleFieldDataChanged}
                    ref={formRef}
                >
                    <GroupItem caption="Ücret Bilgisi">
                        <SimpleItem dataField="salaryCalculationTypeId" editorType="dxSelectBox" editorOptions={salaryCalculationTypeOptions}>
                            <Label text="Hesaplama Tipi" />
                        </SimpleItem>
                        <SimpleItem dataField="amount" >
                            <Label text="Ücret" />
                            <RequiredRule />

                        </SimpleItem>
                        <SimpleItem
                            dataField="salaryPaymentDayId"
                            editorType="dxSelectBox"
                            editorOptions={salaryPaymentDayOptions}>
                            <Label text="Ödeme Günü" />
                        </SimpleItem>
                        <SimpleItem dataField="salaryPaymentMethodId" editorType="dxSelectBox" editorOptions={salaryPaymentMethodOptions}>
                            <Label text="Ödeme Methodu" />
                        </SimpleItem>
                    </GroupItem>

                </Form>
            </BaseFormWithBreadCrumbs>

        </React.Fragment>
    )
}

export default Salary
